import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import Header from "../../global/header";
import Footer from "../../global/footer";
import Title from "../Title/Title";
import Language from "../Language/Langauge";

import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import "./Instruction.css";
import tokenService from "../../service/token.service";
import { appConfig } from "../../config/appConfig";
import { useNavigate } from "react-router-dom";

const Instruction = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleClick = () => {
    sessionStorage.setItem("visitedEmailHidden", "true");
    navigate("/restartPage");
  };

useEffect(() => {
  // Save timestamp of visit in localStorage
  const now = Date.now();
  localStorage.setItem("visitedEmailHidden", now.toString());

  const timer = setTimeout(() => {
    navigate("/restartPage");
  }, 5 * 60 * 1000); // 5 minutes

  return () => clearTimeout(timer);
}, []);

  return (
    <>
      <Header />
      <Container className="instruction">
        <Row>
          <Col lg="1" />
          <Col lg="10" className="middlePadding">
            <div>
              <Title logoType="Success">
                {" "}
                {t("TEXT_EMAIL_HIDDEN_PAGE_TITLE")}{" "}
              </Title>
              <Language />
            </div>
            <div className="mb-3">
              <Card className="card contentCard" text="black">
                <Card.Body>
                  <Card.Text className="cardText">
                    {t("TEXT_EMAIL_HIDDEN_INSRUCTION_1")}{" "}
                    <span className="emailText">
                      {tokenService.getUserInfo()?.email}
                    </span>{" "}
                    {t("TEXT_EMAIL_HIDDEN_INSRUCTION_3")}
                    <div>{t("TEXT_EMAIL_HIDDEN_INSRUCTION_4")}</div>
                  </Card.Text>
                  <Card.Text className="cardText">
                    {t("TEXT_EMAIL_HIDDEN_INSRUCTION_5")}{" "}
                    {t("TEXT_EMAIL_HIDDEN_INSRUCTION_6")}
                  </Card.Text>
                </Card.Body>
                <Card.Body className="linkBody">
                  <Card.Link
                    className="cardLink"
                    target="_blank"
                    href={appConfig.EMAIL_HIDDEN_INSTRUCTION_URL}
                  >
                    {t("TEXT_EMAIL_HIDDEN_INSRUCTION_8")}
                  </Card.Link>
                </Card.Body>
              </Card>
              <div className="d-grid gap-2">
                <Button onClick={handleClick} className="backBtn">
                  {t("LABEL_NEXT_BUTTON")}
                </Button>
              </div>
            </div>
            <Footer />
          </Col>
          <Col lg="1" />
        </Row>
      </Container>
    </>
  );
};

export default Instruction;
